export const UPDATE_CONFIG = 'app/DeviceAdmin/UPDATE_CONFIG';
export const UPDATE_CONFIG_SUCCESS = 'app/DeviceAdmin/UPDATE_CONFIG_SUCCESS';
export const UPDATE_CONFIG_COMPLETE = 'app/DeviceAdmin/UPDATE_CONFIG_COMPLETE';

export const DEVICE_REQUEST = 'app/DeviceAdmin/DEVICE_REQUEST';
export const DEVICE_REQUEST_COMPLETE = 'app/DeviceAdmin/DEVICE_REQUEST_COMPLETE';
export const DEVICE_REQUEST_SUCCESS = 'app/DeviceAdmin/DEVICE_REQUEST_SUCCESS';

export const CONFIG_REQUEST = 'app/DeviceAdmin/CONFIG_REQUEST';
export const CONFIG_REQUEST_COMPLETE = 'app/DeviceAdmin/CONFIG_REQUEST_COMPLETE';
export const CONFIG_REQUEST_SUCCESS = 'app/DeviceAdmin/CONFIG_REQUEST_SUCCESS';

export const CREATE_DEVICE = 'app/DeviceAdmin/CREATE_DEVICE';
export const CREATE_DEVICE_COMPLETE = 'app/DeviceAdmin/CREATE_DEVICE_COMPLETE';
export const CREATE_DEVICE_SUCCESS = 'app/DeviceAdmin/CREATE_DEVICE_SUCCESS';

export const INVITES_REQUEST = 'app/DeviceAdmin/INVITES_REQUEST';
export const INVITES_REQUEST_COMPLETE = 'app/DeviceAdmin/INVITES_REQUEST_COMPLETE';
export const INVITES_REQUEST_SUCCESS = 'app/DeviceAdmin/INVITES_REQUEST_SUCCESS';

export const INVITES_UPLOAD = 'app/DeviceAdmin/INVITES_UPLOAD';
export const INVITES_UPLOAD_COMPLETE = 'app/DeviceAdmin/INVITES_UPLOAD_COMPLETE';
export const INVITES_UPLOAD_SUCCESS = 'app/DeviceAdmin/INVITES_UPLOAD_SUCCESS';

export const REVIEWS_REQUEST = 'app/DeviceAdmin/REVIEWS_REQUEST';
export const REVIEWS_REQUEST_COMPLETE = 'app/DeviceAdmin/REVIEWS_REQUEST_COMPLETE';
export const REVIEWS_REQUEST_SUCCESS = 'app/DeviceAdmin/REVIEWS_REQUEST_SUCCESS';

export const REVIEW_REPLY = 'app/DeviceAdmin/REVIEW_REPLY';
export const REVIEW_REPLY_COMPLETE = 'app/DeviceAdmin/REVIEW_REPLY_COMPLETE';
export const REVIEW_REPLY_SUCCESS = 'app/DeviceAdmin/REVIEW_REPLY_SUCCESS';

export const EVIDENCE_REQUEST = 'app/DeviceAdmin/EVIDENCE_REQUEST';
export const EVIDENCE_REQUEST_COMPLETE =
  'app/DeviceAdmin/EVIDENCE_REQUEST_COMPLETE';
export const EVIDENCE_REQUEST_SUCCESS = 'app/DeviceAdmin/EVIDENCE_REQUEST_SUCCESS';

export const EVIDENCE_TABLE_REQUEST = 'app/DeviceAdmin/EVIDENCE_TABLE_REQUEST';
export const EVIDENCE_TABLE_REQUEST_COMPLETE =
  'app/DeviceAdmin/EVIDENCE_TABLE_REQUEST_COMPLETE';
export const EVIDENCE_TABLE_REQUEST_SUCCESS =
  'app/DeviceAdmin/EVIDENCE_TABLE_REQUEST_SUCCESS';

export const SCHOOL_TYPE_CHANGE = 'app/DeviceAdmin/SCHOOL_TYPE_CHANGE';
export const SCHOOL_SIZE_CHANGE = 'app/DeviceAdmin/SCHOOL_SIZE_CHANGE';
export const RESET_STATE = 'app/DeviceAdmin/RESET_STATE';

export const DEVICES_TOGGLE_FILTER = 'app/DeviceAdmin/DEVICES_TOGGLE_FILTER';
export const DEVICES_TOGGLE_SUBJECT = 'app/DeviceAdmin/DEVICES_TOGGLE_SUBJECT';
export const DEVICES_TOGGLE_FEATURE = 'app/DeviceAdmin/DEVICES_TOGGLE_FEATURE';
export const DEVICES_TOGGLE_TYPE = 'app/DeviceAdmin/DEVICES_TOGGLE_TYPE';

export const SELECT_DEVICE = 'app/DeviceAdmin/SELECT_DEVICE';
export const SELECT_DEVICE_SUCCESS = 'app/DeviceAdmin/SELECT_DEVICE_SUCCESS';
export const SELECT_DEVICE_COMPLETE = 'app/DeviceAdmin/SELECT_DEVICE_COMPLETE';

export const DEVICES_TOGGLE_CHECKBOX =
  'app/DeviceAdmin/DEVICES_TOGGLE_CHECKBOX';
export const UPDATE_DEVICE = 'app/DeviceAdmin/UPDATE_DEVICE';
export const COMPLETE_UPDATE_DEVICE = 'app/DeviceAdmin/COMPLETE_UPDATE_DEVICE';
export const DEVICES_SELECT_PLAN = 'app/DeviceAdmin/SELECT_PLAN';
export const EMAILS_CHANGE = 'app/DeviceAdmin/EMAILS_CHANGE';
export const REVIEW_CHANGE = 'app/DeviceAdmin/REVIEW_CHANGE';
export const WIDGET_DETAILS_CHANGE = 'app/DeviceAdmin/WIDGET_DETAILS_CHANGE';
export const EXPORT_REVIEWS = 'app/DeviceAdmin/EXPORT_REVIEWS';
export const EXPORT_ALL_REVIEWS = 'app/DeviceAdmin/EXPORT_ALL_REVIEWS';
export const EXPORT_ALL_DEVICES = 'app/DeviceAdmin/EXPORT_ALL_DEVICES';
export const EXPORT_COMPLETE = 'app/DeviceAdmin/EXPORT_COMPLETE';
export const UPLOAD_LOGO = 'app/DeviceAdmin/UPLOAD_LOGO';
export const UPLOAD_SCREENSHOT = 'app/DeviceAdmin/UPLOAD_SCREENSHOT';
export const UPLOAD_EVIDENCE = 'app/DeviceAdmin/UPLOAD_EVIDENCE';
export const DELETE_EVIDENCE = 'app/DeviceAdmin/DELETE_EVIDENCE';

export const schoolTypes = [
  { id: 1, title: 'Primary', value: 'Primary' },
  { id: 2, title: 'Secondary', value: 'Secondary' },
  { id: 3, title: 'International', value: 'International' },
];

export const schoolSizes = [
  {
    id: 1,
    title: '100 students or less',
    value: {
      min: 0,
      max: 100,
    },
  },
  {
    id: 2,
    title: '101-500 students',
    value: {
      min: 101,
      max: 500,
    },
  },
  {
    id: 3,
    title: '501-1000 students',
    value: {
      min: 501,
      max: 1000,
    },
  },
  {
    id: 4,
    title: '1000+ students',
    value: {
      min: 1001,
      max: 100000,
    },
  },
];
